'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestFailed = undefined;

var _identity = require('transmute/identity');

var _identity2 = _interopRequireDefault(_identity);

var _asyncStatuses = require('../constants/asyncStatuses');

var _requestStateUpdate = require('./requestStateUpdate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Set status when a request fails
 *
 * @param {AsyncData} asyncData AsyncData record to update
 * @returns {AsyncData}
*/
var requestFailed = exports.requestFailed = (0, _requestStateUpdate.requestStateUpdate)(_asyncStatuses.FAILED, _identity2.default);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/async-data/operators/requestFailed.js
// module id = 277
// module chunks = 2 3